
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogTagEN]",
      function () {
        return require("private-next-pages/[...blogTagEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogTagEN]"])
      });
    }
  